import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  Checkbox,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  Box,
  makeStyles,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  FormControl,
  Select,
  Radio,
  Tab,
} from "@material-ui/core";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import { appUrl } from "../../../../../../utils/config";
import { useDispatch } from "react-redux";
import FlagIcon from "@material-ui/icons/Flag";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import { ChevronRight } from "@material-ui/icons";
import BackDropLoading from "../../models/BackDrop";
import jwtDecode from "jwt-decode";
import { set } from "lodash";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    border: "2px solid #ccc",
    borderRadius: "8px",
    overflow: "auto",
    maxWidth: "99%",
  },
  commentField: {
    "& .MuiInputBase-input": {
      lineHeight: "1.2rem",
    },
  },

  headerCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    lineHeight:"2rem",
    whiteSpace: "nowrap",
    position: 'sticky',
    top: 0,
    // backgroundColor: '#fff',
    zIndex: 1,
  },
  customSelect: {
    minWidth: 150,
  },
  customRadio: {
    color: "#ec6535 !important", // Selected radio button color
  },
  customCheckbox: {
    color: "#ec6535 !important", // Checked checkbox color
  },
  customSelectSty: {
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  textField:{
    "& .MuiInputBase-root": {
    lineHeight:"0.6rem",
    },
  },
  tablepadding:{
    "& .MuiTableCell-root":{
      padding:"2px"
    }, 
  },
  secondTablepadding:{
    "& .MuiTableCell-root":{
      padding:"2px"
    },
  },
  updatedHeader: {
    // "& .MuiTableCell-root":{
    //   padding:"0px"
    // },
    fontWeight: 700,
    fontSize: 13.6,
    },
  updatedSubHeader: {
    fontSize: 13.6,
     padding:"0px"
  },
  updatedTableContainer: {
    border: "2px solid #ccc",
    borderRadius: "1px",
    overflow: "auto",
    maxWidth: "99%",
   maxHeight: 150,
  },
}));

const EditPlannedAllocatedQuantityDialog = ({
  lotData,
  rmPmCode,
  onClose,
  poData,
  schrockenSLID,
  vendorMosymphonyID,
  handleClose,
  lotAllocationData,
  lotAllocationRes
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [updatedInventory, setUpdatedInventory] = useState(
    lotData?.inventoryDetails && Array.isArray(lotData.inventoryDetails)
      ? [...lotData.inventoryDetails]
      : []
  );
  
  const [allowMultipleLotAllocation , setAllowMultipleLotAllocation] = useState(false);
  const [allowOverAllocation , setAllowOverAllocation] = useState(false);
  const [overAllocationLimit , setOverAllocationLimit] = useState(0);
  const [allowUnderAllocation , setAllowUnderAllocation] = useState(false);
  const [underAllocationLimit , setUnderAllocationLimit] = useState(0);
  const [inputErrors, setInputErrors] = useState({});
  const [totalAllocationError, setTotalAllocationError] = useState("");

  useEffect(() => {
    if (
      Array.isArray(lotAllocationData) &&
      lotAllocationData.length > 0 &&
      Array.isArray(lotAllocationData[0].lotNumberAllocationDetails) &&
      lotAllocationData[0].lotNumberAllocationDetails.length > 0
    ) {
      setAllowMultipleLotAllocation(
        lotAllocationData[0].lotNumberAllocationDetails[0].allowMultipleLotAllocation
      );
      setAllowOverAllocation(false); // Always start unchecked
      setOverAllocationLimit(
        lotAllocationData[0].lotNumberAllocationDetails[0].overAllocationLimit
      );
      setAllowUnderAllocation(false);
      setUnderAllocationLimit(
        lotAllocationData[0].lotNumberAllocationDetails[0].allowUnderAllocationLimit || 
        lotAllocationData[0].lotNumberAllocationDetails[0].underAllocationLimit || 
        0
      );
    }
  }, [lotAllocationData]);

  const [reasonCodes, setReasonCodes] = useState([]);
  const [rmpmChecked, setrmpmChecked] = useState(true);
  const [selectedReason, setSelectedReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [selectedLot, setSelectedLot] = useState(null);
  const [netAvailableQty, setNetAvailableQty] = useState(null);
  const [selectedLotDataState, setSelectedLotDataState] = useState(null);

  // Enable Save button conditionally
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  
  // State to track deplete instruction checkboxes for each row
  // Key: row index, Value: boolean indicating if deplete instruction should be added
  const [depleteInstructions, setDepleteInstructions] = useState({});

  const [disableReasonCode, setDisableReasonCode] = useState(false);
  const [errorInfo, setErrorInfo] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  // Sync inventoryDetails when it changes
  useEffect(() => {
    if (lotData?.inventoryDetails && Array.isArray(lotData.inventoryDetails)) {
      setUpdatedInventory([...lotData.inventoryDetails]);
      // Initialize deplete instructions state - all unchecked by default
      const initialDepleteInstructions = {};
      lotData.inventoryDetails.forEach((item, index) => {
        initialDepleteInstructions[index] = false;
      });
      setDepleteInstructions(initialDepleteInstructions);
    }
  }, [lotData]);

  useEffect(() => {
    
    dispatch({
      type: DESTROY_BACKDROP,
    });
    
    
    return () => {
      dispatch({
        type: DESTROY_BACKDROP,
      });
    };
  }, [dispatch]);
  
  const handleInputChange = (index, value) => {
    if (!Array.isArray(updatedInventory)) return;

    let enteredValue = value.match(/^[0-9]*\.?[0-9]{0,3}$/)
      ? value
      : updatedInventory[index]?.plannedAllocatedQuantity || "";

    const newInventory = [...updatedInventory];
    newInventory[index] = {
      ...newInventory[index],
      plannedAllocatedQuantity: enteredValue,
    };
    setUpdatedInventory(newInventory);

    // If quantity is cleared or zero, uncheck the deplete instruction for this row
    if (!rmpmChecked && (!enteredValue || parseFloat(enteredValue) <= 0)) {
      setDepleteInstructions((prev) => ({
        ...prev,
        [index]: false,
      }));
    }

    const componentQuantity = parseFloat(
      lotData?.componentAllocationDetails?.componentQuantity || 0
    );
    const enteredNumber = parseFloat(enteredValue);
    let errorMsg = "";

    const requiredQuantity = parseFloat(
      lotData?.componentAllocationDetails?.componentQuantity || 0
    );

    // Calculate total entered quantity
    const totalEnteredQuantity = newInventory.reduce(
      (acc, item) => acc + (parseFloat(item.plannedAllocatedQuantity) || 0),
      0
    );

    let totalErrorMsg = "";
    const isExactMatch = totalEnteredQuantity.toFixed(3) === requiredQuantity.toFixed(3);

    
    if (!rmpmChecked) {
     
      if (enteredValue !== "" && enteredNumber > 0) {
        const netAvailableQty = parseFloat(newInventory[index]?.netAvailableQuantity || 0);
        if (enteredNumber > netAvailableQty) {
          errorMsg = `Planned Allocated Qty. exceeds Net Available Qty. for this material batch number.`;
        }
      }

     
      const allRowErrors = {};
      newInventory.forEach((item, idx) => {
        const qty = parseFloat(item.plannedAllocatedQuantity || 0);
        if (qty > 0) {
          const netQty = parseFloat(item.netAvailableQuantity || 0);
          if (qty > netQty) {
            allRowErrors[idx] = `Planned Allocated Qty. exceeds Net Available Qty. for this material batch number.`;
          }
        }
      });

     
      const allRowLevelPassed = Object.keys(allRowErrors).length === 0;

      
      const enteredValuesCount = newInventory.filter(
        (item) => parseFloat(item.plannedAllocatedQuantity || 0) > 0
      ).length;

      
      if (allRowLevelPassed) {
        
        if (allowOverAllocation && enteredValue !== "" && enteredNumber > 0) {
         
          const maxAllowed = requiredQuantity + (overAllocationLimit * requiredQuantity / 100);
          
          if (enteredValuesCount === 1) {
            // Single value: validate individual value against calculated limit (BOM + over-allocation percentage)
            const enteredQty = parseFloat(enteredNumber.toFixed(3));
            const reqQty = parseFloat(requiredQuantity.toFixed(3));
            const maxAllowedQty = parseFloat(maxAllowed.toFixed(3));
            
            if (enteredQty > maxAllowedQty) {
              errorMsg = `Over-Allocation Limit Exceeded: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds the maximum allowed over-allocation limit of ${maxAllowed.toFixed(3)} (Material BoM Qty: ${requiredQuantity.toFixed(3)} + Over-allocation: ${overAllocationLimit}%).`;
            } else if (enteredQty < reqQty) {
              errorMsg = `Allocation Below Material BoM Qty: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) is less than Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
          } else if (enteredValuesCount > 1) {
           
            errorMsg = ""; // Clear individual row error when multiple values are entered
            const totalQty = parseFloat(totalEnteredQuantity.toFixed(3));
            const reqQty = parseFloat(requiredQuantity.toFixed(3));
            const maxAllowedQty = parseFloat(maxAllowed.toFixed(3));
            
            if (totalQty > maxAllowedQty) {
              // Sum exceeds maxAllowed limit (BOM + over-allocation percentage) - show error with calculated limit
              totalErrorMsg = `Over-Allocation Limit Exceeded: The total Planned Allocated Qty. (${totalEnteredQuantity.toFixed(3)}) exceeds the maximum allowed over-allocation limit of ${maxAllowed.toFixed(3)} (Material BoM Qty: ${requiredQuantity.toFixed(3)} + Over-allocation: ${overAllocationLimit}%).`;
            } else if (totalQty < reqQty) {
              // Sum is below requiredQuantity - show error
              totalErrorMsg = `Allocation Below Material BoM Qty: The total Planned Allocated Qty. (${totalEnteredQuantity.toFixed(3)}) is less than Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
           
          }
        } else if (allowUnderAllocation && enteredValue !== "" && enteredNumber > 0) {
          // Under allocation validation for multiple batch
          const minAllowed = requiredQuantity - (underAllocationLimit * requiredQuantity / 100);
          
          if (enteredValuesCount === 1) {
            // Single value: validate individual value against calculated limit (BOM - under-allocation percentage)
            const enteredQty = parseFloat(enteredNumber.toFixed(3));
            const reqQty = parseFloat(requiredQuantity.toFixed(3));
            const minAllowedQty = parseFloat(minAllowed.toFixed(3));
            
            if (enteredQty < minAllowedQty) {
              errorMsg = `Under-Allocation Limit Exceeded: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) is below the minimum allowed under-allocation limit of ${minAllowed.toFixed(3)} (Material BoM Qty: ${requiredQuantity.toFixed(3)} - Under-allocation: ${underAllocationLimit}%).`;
            } else if (enteredQty > reqQty) {
              errorMsg = `Allocation Above Material BoM Qty: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds the Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
          } else if (enteredValuesCount > 1) {
           
            errorMsg = ""; // Clear individual row error when multiple values are entered
            const totalQty = parseFloat(totalEnteredQuantity.toFixed(3));
            const reqQty = parseFloat(requiredQuantity.toFixed(3));
            const minAllowedQty = parseFloat(minAllowed.toFixed(3));
            
            if (totalQty < minAllowedQty) {
              // Sum is below minAllowed limit (BOM - under-allocation percentage) - show error with calculated limit
              totalErrorMsg = `Under-Allocation Limit Exceeded: The total Planned Allocated Qty. (${totalEnteredQuantity.toFixed(3)}) is below the minimum allowed under-allocation limit of ${minAllowed.toFixed(3)} (Material BoM Qty: ${requiredQuantity.toFixed(3)} - Under-allocation: ${underAllocationLimit}%).`;
            } else if (totalQty > reqQty) {
              // Sum exceeds requiredQuantity - show error
              totalErrorMsg = `Allocation Above Material BoM Qty: The total Planned Allocated Qty. (${totalEnteredQuantity.toFixed(3)}) exceeds the Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
          
          }
        } else {
          // No over/under allocation: use original BOM validation
          if (enteredValuesCount === 1 && enteredValue !== "" && enteredNumber > 0) {
            // If only one value entered, check individual value vs BOM Qty
            if (enteredNumber > requiredQuantity) {
              errorMsg = `Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
          } else if (enteredValuesCount > 1) {
            // If multiple values entered, check sum vs BOM Qty
            const totalQty = parseFloat(totalEnteredQuantity.toFixed(3));
            const reqQty = parseFloat(requiredQuantity.toFixed(3));
            if (totalQty > reqQty) {
              totalErrorMsg = `Total allocation mismatch: Sum of Planned Allocated Qty. (${totalEnteredQuantity.toFixed(3)}) exceeds Material BoM Qty. (${requiredQuantity.toFixed(3)}).`;
            }
          }
        }
      }

     
      setInputErrors((prev) => {
        const newErrors = { ...prev };
        // Update all row-level errors
        Object.keys(allRowErrors).forEach((key) => {
          newErrors[key] = allRowErrors[key];
        });
        // Update current row's BOM/over/under allocation error (if any)
        if (errorMsg && !allRowErrors[index]) {
          newErrors[index] = errorMsg;
        } else if (!errorMsg && !allRowErrors[index]) {
          // Clear BOM/over/under allocation error for current row if it passes
          const currentError = newErrors[index];
          if (currentError && (
            currentError.includes("exceeds Material BoM Qty") ||
            currentError.includes("Over-Allocation Limit Exceeded") ||
            currentError.includes("Under-Allocation Limit Exceeded") ||
            currentError.includes("Allocation Below Material BoM Qty") ||
            currentError.includes("Allocation Above Material BoM Qty")
          )) {
            delete newErrors[index];
          }
        }
        // Clear row-level errors for rows that now pass
        Object.keys(newErrors).forEach((key) => {
          if (!allRowErrors[key] && newErrors[key]?.includes("exceeds Net Available Qty")) {
            delete newErrors[key];
          }
        });
       
        if (enteredValuesCount > 1 && (allowOverAllocation || allowUnderAllocation)) {
          Object.keys(newErrors).forEach((key) => {
            const errorText = newErrors[key];
            if (errorText && (
              errorText.includes("Over-Allocation Limit Exceeded") ||
              errorText.includes("Under-Allocation Limit Exceeded") ||
              errorText.includes("Allocation Below Material BoM Qty") ||
              errorText.includes("Allocation Above Material BoM Qty")
            )) {
              delete newErrors[key];
            }
          });
        }
        // If sum error exists, clear all individual BOM/over/under allocation errors
        if (totalErrorMsg) {
          Object.keys(newErrors).forEach((key) => {
            const errorText = newErrors[key];
            if (errorText && (
              (errorText.includes("exceeds Material BoM Qty") && !errorText.includes("Allocation Above Material BoM Qty") && !errorText.includes("Allocation Below Material BoM Qty")) ||
              errorText.includes("Over-Allocation Limit Exceeded") ||
              errorText.includes("Under-Allocation Limit Exceeded") ||
              errorText.includes("Allocation Below Material BoM Qty") ||
              errorText.includes("Allocation Above Material BoM Qty")
            )) {
              delete newErrors[key];
            }
          });
        }
        return newErrors;
      });
    } else {
      
      totalErrorMsg = ""; // Clear sum errors for single batch
      
      if (enteredValue !== "" && enteredNumber > 0) {
        const netAvailableQty = parseFloat(newInventory[index]?.netAvailableQuantity || 0);
        if (enteredNumber > netAvailableQty) {
          errorMsg = `Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds Net Available Qty. (${netAvailableQty.toFixed(3)}) for this material batch number.`;
        } else {
          
          if (allowOverAllocation) {
            // Over allocation validation only - validate against calculated limit (BOM + over-allocation percentage)
            const maxAllowed = componentQuantity + (overAllocationLimit * componentQuantity / 100);
            const enteredQty = parseFloat(enteredNumber.toFixed(3));
            const compQty = parseFloat(componentQuantity.toFixed(3));
            const maxAllowedQty = parseFloat(maxAllowed.toFixed(3));
            
            if (enteredQty > maxAllowedQty) {
              errorMsg = `Over-Allocation Limit Exceeded: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds the maximum allowed over-allocation limit of ${maxAllowed.toFixed(3)} (Material BoM Qty: ${componentQuantity.toFixed(3)} + Over-allocation: ${overAllocationLimit}%).`;
            } else if (enteredQty < compQty) {
              errorMsg = `Allocation Below Material BoM Qty: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) is less than Material BoM Qty. (${componentQuantity.toFixed(3)}).`;
            }
          } else if (allowUnderAllocation) {
            // Under allocation validation only - validate against calculated limit (BOM - under-allocation percentage)
            const minAllowed = componentQuantity - (underAllocationLimit * componentQuantity / 100);
            const enteredQty = parseFloat(enteredNumber.toFixed(3));
            const compQty = parseFloat(componentQuantity.toFixed(3));
            const minAllowedQty = parseFloat(minAllowed.toFixed(3));
            
            if (enteredQty < minAllowedQty) {
              errorMsg = `Under-Allocation Limit Exceeded: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) is below the minimum allowed under-allocation limit of ${minAllowed.toFixed(3)} (Material BoM Qty: ${componentQuantity.toFixed(3)} - Under-allocation: ${underAllocationLimit}%).`;
            } else if (enteredQty > compQty) {
              errorMsg = `Allocation Above Material BoM Qty: The entered Planned Allocated Qty. (${enteredNumber.toFixed(3)}) exceeds the Material BoM Qty. (${componentQuantity.toFixed(3)}).`;
            }
          }
        }
      }

      
      setInputErrors((prev) => {
        const newErrors = { ...prev, [index]: errorMsg };
        
        Object.keys(newErrors).forEach((key) => {
          const errorText = newErrors[key];
          // Clear multiple allocation errors
          if (errorText && (
            errorText.includes("exceeds Net Available Qty") && !errorText.includes("exceeds Net Available Qty. (") || // Multiple allocation row-level error (no values)
            errorText.includes("exceeds Material BoM Qty") && !errorText.includes("Allocation Above Material BoM Qty") // Multiple allocation BOM error
          )) {
            delete newErrors[key];
          }
        });
        return newErrors;
      });
    }
    
    setTotalAllocationError(totalErrorMsg);

    // Disable other inputs if one textbox equals required quantity
    const shouldDisableOthers = newInventory.some(
      (item) =>
        parseFloat(item.plannedAllocatedQuantity).toFixed(3) ===
        requiredQuantity.toFixed(3)
    );

    setUpdatedInventory(
      newInventory.map((item, i) => ({
        ...item,
        disabled: shouldDisableOthers && i !== index,
      }))
    );

    
    let hasRowErrors = false;
    let hasTotalError = false;
    
    if (!rmpmChecked) {
      
      const finalErrors = { ...inputErrors };
      // Add all row-level errors
      newInventory.forEach((item, idx) => {
        const qty = parseFloat(item.plannedAllocatedQuantity || 0);
        if (qty > 0) {
          const netQty = parseFloat(item.netAvailableQuantity || 0);
          if (qty > netQty) {
            finalErrors[idx] = `Planned Allocated Qty. exceeds Net Available Qty. for this material batch number.`;
          }
        }
      });
     
      if (errorMsg && !finalErrors[index]) {
        finalErrors[index] = errorMsg;
      }
      // If sum error exists, clear individual BOM errors
      if (totalErrorMsg) {
        Object.keys(finalErrors).forEach((key) => {
          if (finalErrors[key]?.includes("exceeds Material BoM Qty")) {
            delete finalErrors[key];
          }
        });
      }
      hasRowErrors = Object.values(finalErrors).some((msg) => msg && msg.length > 0);
      hasTotalError = totalErrorMsg.length > 0; // Only check sum errors for multiple allocation
    } else {
      // For single batch, use simple check - only check over/under allocation errors
      const updatedErrors = { ...inputErrors, [index]: errorMsg };
      hasRowErrors = Object.values(updatedErrors).some((msg) => msg && msg.length > 0);
      // No sum errors for single batch allocation
      hasTotalError = false;
    }
    
    if (hasRowErrors || hasTotalError) {
      // Validation errors take precedence - keep save disabled
      setIsSaveEnabled(false);
      return;
    }

    // If no validation errors, proceed with normal save button logic
    const areAllLotNumberDetailsEmpty = lotAllocationData?.every(
      (item) => item?.lotNumberAllocationDetails?.length === 0
    );
    
    // Check if values are within over/under allocation limits (when enabled)
    let isWithinAllocationLimits = false;
    if (allowOverAllocation || allowUnderAllocation) {
      const enteredValuesCount = newInventory.filter(
        (item) => parseFloat(item.plannedAllocatedQuantity || 0) > 0
      ).length;
      
      if (enteredValuesCount > 0) {
        if (allowOverAllocation) {
          const maxAllowed = requiredQuantity + (overAllocationLimit * requiredQuantity / 100);
          isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(requiredQuantity.toFixed(3)) && 
                                      parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(maxAllowed.toFixed(3));
        } else if (allowUnderAllocation) {
          const minAllowed = requiredQuantity - (underAllocationLimit * requiredQuantity / 100);
          isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(minAllowed.toFixed(3)) && 
                                      parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(requiredQuantity.toFixed(3));
        }
      }
    }
    
    // If checkbox is checked, only validate comment 
    if (!rmpmChecked) {
     
      const isValidAllocation = isExactMatch || isWithinAllocationLimits;
      
      setIsSaveEnabled(
        areAllLotNumberDetailsEmpty
          // ? isValidAllocation ||
          //     selectedReason.trim() !== "" ||
          //     comment.trim() !== ""
          // : isValidAllocation &&
          //     ((selectedReason !== "" && selectedReason !== "EXMRP019") ||
          //       (selectedReason === "EXMRP019" && comment.trim() !== ""))
          ? isValidAllocation || comment.trim() !== ""
          : isValidAllocation && comment.trim() !== ""
      );
    } else if (rmpmChecked) {
      //setIsSaveEnabled(selectedReason.trim() !== "" || comment.trim() !== "");
      setIsSaveEnabled(comment.trim() !== "");
    } else {
      setIsSaveEnabled(
        //isExactMatch && (selectedReason.trim() !== "" || comment.trim() !== "")
        isExactMatch && comment.trim() !== ""
      );
    }
  };

  // Handle Save
  const handleSave = () => {
    let lotNumberAllocationDetails = [];

    if (rmpmChecked) {
     
      if (selectedLot && allowOverAllocation) {
       
        const selectedLotItem = updatedInventory.find(item => item.inventoryBatchNumber === selectedLot);
        const userEnteredQty = selectedLotItem?.plannedAllocatedQuantity 
          ? parseFloat(selectedLotItem.plannedAllocatedQuantity) 
          : parseFloat(selectedLotDataState?.boNetAvailableQuantity || 0);
        
        let convertedValue = userEnteredQty;
        if (lotData?.componentAllocationDetails?.conversionOperator == "=") {
          convertedValue = userEnteredQty;
        } else if (lotData?.componentAllocationDetails?.conversionOperator == "/") {
          convertedValue = userEnteredQty / lotData?.componentAllocationDetails?.conversionConstant;
        } else if (lotData?.componentAllocationDetails?.conversionOperator == "*") {
          convertedValue = userEnteredQty * lotData?.componentAllocationDetails?.conversionConstant;
        }

        // Find the index of the selected lot to get its deplete instruction checkbox state
        const selectedLotIndex = updatedInventory.findIndex(
          (item) => item.inventoryBatchNumber === selectedLot
        );
        lotNumberAllocationDetails = [
          {
            plannedAllocatedQuantity: localStorage.collabType === "CMO" ? convertedValue : userEnteredQty,
            lotNumber: selectedLotDataState?.boInventoryBatchNumber,
            cmoLotNumber: selectedLotDataState?.cmoInventoryBatchNumber,
            // Include whether user wants to add deplete instruction for this batch
            isDepletedBatch: depleteInstructions[selectedLotIndex] || false,
          },
        ];
      } else if (selectedLot && allowUnderAllocation) {
        
        const selectedLotItem = updatedInventory.find(item => item.inventoryBatchNumber === selectedLot);
        const userEnteredQty = selectedLotItem?.plannedAllocatedQuantity 
          ? parseFloat(selectedLotItem.plannedAllocatedQuantity) 
          : parseFloat(selectedLotDataState?.boNetAvailableQuantity || 0);
        
        let convertedValue = userEnteredQty;
        if (lotData?.componentAllocationDetails?.conversionOperator == "=") {
          convertedValue = userEnteredQty;
        } else if (lotData?.componentAllocationDetails?.conversionOperator == "/") {
          convertedValue = userEnteredQty / lotData?.componentAllocationDetails?.conversionConstant;
        } else if (lotData?.componentAllocationDetails?.conversionOperator == "*") {
          convertedValue = userEnteredQty * lotData?.componentAllocationDetails?.conversionConstant;
        }

        // Find the index of the selected lot to get its deplete instruction checkbox state
        const selectedLotIndex = updatedInventory.findIndex(
          (item) => item.inventoryBatchNumber === selectedLot
        );
        lotNumberAllocationDetails = [
          {
            plannedAllocatedQuantity: localStorage.collabType === "CMO" ? convertedValue : userEnteredQty,
            lotNumber: selectedLotDataState?.boInventoryBatchNumber,
            cmoLotNumber: selectedLotDataState?.cmoInventoryBatchNumber,
            // Include whether user wants to add deplete instruction for this batch
            isDepletedBatch: depleteInstructions[selectedLotIndex] || false,
          },
        ];
      } else if (selectedLot) {
        // Find the index of the selected lot to get its deplete instruction checkbox state
        const selectedLotIndex = updatedInventory.findIndex(
          (item) => item.inventoryBatchNumber === selectedLot
        );
        lotNumberAllocationDetails = [
          {
            // plannedAllocatedQuantity: parseFloat(
            //   lotData?.componentAllocationDetails?.componentQuantity || 0
            // ),
            // lotNumber: selectedLot,
           
            plannedAllocatedQuantity: parseFloat(lotData?.componentAllocationDetails?.boComponentQuantity || 0),
            lotNumber: selectedLotDataState?.boInventoryBatchNumber,
            cmoLotNumber: selectedLotDataState?.cmoInventoryBatchNumber,
            // Include whether user wants to add deplete instruction for this batch
            isDepletedBatch: depleteInstructions[selectedLotIndex] || false,
          },
        ];
      }
    } else {
      // Case 1: User Entered Values in Textboxes
      lotNumberAllocationDetails = updatedInventory
        .filter((item) => parseFloat(item.plannedAllocatedQuantity) > 0) // Only include filled textboxes
        .map((item, itemIndex) => {
          const userValue = parseFloat(item.plannedAllocatedQuantity);
          let convertedValue = userValue;

          if (lotData?.componentAllocationDetails?.conversionOperator == "=") {
            convertedValue = userValue;
          } else if (lotData?.componentAllocationDetails?.conversionOperator == "/") {
            convertedValue = userValue / lotData?.componentAllocationDetails?.conversionConstant;
          } else if (lotData?.componentAllocationDetails?.conversionOperator == "*") {
            convertedValue = userValue * lotData?.componentAllocationDetails?.conversionConstant;
          }

          // Find the original index in updatedInventory to get the deplete instruction checkbox state
          const originalIndex = updatedInventory.findIndex(
            (invItem) => invItem.inventoryBatchNumber === item.inventoryBatchNumber
          );

          return {
            plannedAllocatedQuantity: localStorage.collabType === "CMO" ? convertedValue : userValue,
          // lotNumber: item.inventoryBatchNumber,
            lotNumber: item.boInventoryBatchNumber,
            cmoLotNumber: item?.cmoInventoryBatchNumber,
            // Include whether user wants to add deplete instruction for this batch
            isDepletedBatch: depleteInstructions[originalIndex] || false,
          };
        });
    }

    // Include Previous Lot Allocations from lotData
    const previousLotNumberAllocationDetails =
      lotData?.lotNumberAllocationDetails?.map((item) => ({
        // lotNumber: item.lotNumber,
        // plannedAllocatedQuantity: item.plannedAllocatedQuantity,
        lotNumber: localStorage.collabType === "CMO" ? item?.boLotNumber : item?.lotNumber,
        plannedAllocatedQuantity: localStorage.collabType === "CMO" ? item?.boPlannedAllocatedQuantity : item.plannedAllocatedQuantity,
      })) || [];


    // Create Final Payload Object
    const savePayload = {
      schrockenSLID: schrockenSLID,
      lastUpdatedBy: "",
      senderLegalName: "",
      receiverLegalName: "",
      dateChangeFlag: false,
      cdmoOrgID: vendorMosymphonyID,
      // allowOverAllocation: allowOverAllocation,
      overAllocationDone: allowOverAllocation,
      underAllocationDone: allowUnderAllocation,
      poNumber: poData?.scheduleLineDetails?.scheduleAgreementNumber,
      poStatus: poData?.scheduleLineDetails?.scheduleLineStatusText,
      productCodeDiscription: `${poData?.scheduleLineDetails?.fgMaterialCode} / ${poData?.scheduleLineDetails?.fgMaterialName}`,
      bomQty: poData?.scheduleLineDetails?.targetQuantity,
      uom: poData?.scheduleLineDetails?.targetQuantityUOM,
      boProductCode: lotAllocationRes?.boProductCode,
      boProductDescription: lotAllocationRes?.boProductDescription,
      cmoProductCode: lotAllocationRes?.cmoProductCode,
      cmoProductDescription: lotAllocationRes?.cmoProductDescription,
      componentAllocationDataList: [
        {
          componentAllocationDetails: {
            componentCode:
              localStorage.collabType === "CMO"
                ? lotData?.componentAllocationDetails?.boComponentCode
                : lotData?.componentAllocationDetails?.componentCode,
            deliveryScheduleLineCounter:
              lotData?.componentAllocationDetails?.deliveryScheduleLineCounter,
            reasonCode: selectedReason,
            comment: comment.trim(),
            boComponentCode: lotData?.componentAllocationDetails?.boComponentCode,
            boComponentName: lotData?.componentAllocationDetails?.boComponentName,
            cmoComponentCode: lotData?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: lotData?.componentAllocationDetails?.cmoComponentName,
          },
          previousLotNumberAllocationDetails,
          lotNumberAllocationDetails,
        },
      ],
    };




    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait....",
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`,
        savePayload
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: DESTROY_BACKDROP,
          });

          handleClose("success");
        } else {
          handleClose("failed");
          dispatch({
            type: DESTROY_BACKDROP,
          });
        }
      })
      .catch((err) => {
        handleClose("failed");
        dispatch({
          type: DESTROY_BACKDROP,
        });
        // console.log(err);
        // setError(true);
      })
      .finally(() => {
        onClose();
      });
  };

  useEffect(() => {
    const inventory = Array.isArray(lotData?.inventoryDetails)
      ? [...lotData.inventoryDetails]
      : [];
    setUpdatedInventory(inventory);
    // Initialize deplete instructions - all unchecked by default
    const initialDepleteInstructions = {};
    inventory.forEach((item, index) => {
      initialDepleteInstructions[index] = false;
    });
    setDepleteInstructions(initialDepleteInstructions);
  }, [lotData]);
  const getOrganizationIdFromToken = () => {
      const authToken = localStorage.getItem("authToken"); // Get token from localStorage
      if (!authToken) return null; // Return null if no token is found
  
      try {
        const decodedToken = jwtDecode(authToken); // Decode the JWT token
        return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
      } catch (error) {
        console.error("Error decoding JWT token:", error);
        return null;
      }
    };
const collaboratorTypeID = getOrganizationIdFromToken();

  // useEffect(() => {
  //   const requestObject = {
  //     searchField: "all",
  //     searchValue: "",
  //     reasonCodeGroupType: "all",
  //     reasonCodeType: "all",
  //     status: "all",
  //     collaboratorTypeID: "all"

  //   };
  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`,
  //       requestObject
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         if (res.data.data) {
  //           setReasonCodes(res.data.data.reasonCodeList);
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);


  // Ensure rmpmChecked is always true if allowMultipleLotAllocation is false
  useEffect(() => {
    if (
      Array.isArray(lotAllocationData) &&
      lotAllocationData.length > 0 &&
      Array.isArray(lotAllocationData[0].lotNumberAllocationDetails) &&
      lotAllocationData[0].lotNumberAllocationDetails.length > 0 &&
      lotAllocationData[0].lotNumberAllocationDetails[0]?.allowMultipleLotAllocation
    ) {
      setrmpmChecked(false);
    } else {
      setrmpmChecked(true);
    }
  }, [lotAllocationData]);




  // Initialize save button state when component loads
  useEffect(() => {
   
    const hasErrors = Object.values(inputErrors).some((msg) => msg && msg.length > 0) || 
                      (totalAllocationError && totalAllocationError.length > 0);
    
    if (hasErrors) {
      setIsSaveEnabled(false);
      return;
    }

    // Check if lotNumberAllocationDetails exists but has no plannedAllocatedQuantity
    const hasLotDetailsWithoutPlannedQty = 
      Array.isArray(lotData?.lotNumberAllocationDetails) &&
      lotData.lotNumberAllocationDetails.length > 0 &&
      !lotData.lotNumberAllocationDetails.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity'));

    const isLotDetailsEmpty =
      Array.isArray(lotData?.lotNumberAllocationDetails) &&
      lotData?.lotNumberAllocationDetails.length === 0;

    if (hasLotDetailsWithoutPlannedQty || isLotDetailsEmpty) {
      
      if (rmpmChecked) {
        // For single batch mode: check if value is entered when over/under allocation is enabled
        if (allowOverAllocation || allowUnderAllocation) {
          const selectedLotItem = updatedInventory?.find(item => item.inventoryBatchNumber === selectedLot) || null;
          const enteredPlannedQty = selectedLotItem ? parseFloat(selectedLotItem.plannedAllocatedQuantity || 0) : 0;
          const hasEnteredValue = enteredPlannedQty > 0;
          setIsSaveEnabled(selectedLot !== null && hasEnteredValue);
        } else {
          // No over/under allocation: value is auto-set, just need radio selection
          setIsSaveEnabled(selectedLot !== null);
        }
      } else {
        // For text input mode, check exact match or within allocation limits
        const requiredQuantity = parseFloat(
          lotData?.componentAllocationDetails?.componentQuantity || 0
        );
        const totalEnteredQuantity = (updatedInventory || []).reduce(
          (acc, item) => acc + (parseFloat(item.plannedAllocatedQuantity) || 0),
          0
        );
        const isExactMatch =
          totalEnteredQuantity.toFixed(3) === requiredQuantity.toFixed(3);
        
        // Check if values are within over/under allocation limits (when enabled)
        let isWithinAllocationLimits = false;
        if (allowOverAllocation || allowUnderAllocation) {
          const enteredValuesCount = (updatedInventory || []).filter(
            (item) => parseFloat(item.plannedAllocatedQuantity || 0) > 0
          ).length;
          
          if (enteredValuesCount > 0) {
            if (allowOverAllocation) {
              const maxAllowed = requiredQuantity + (overAllocationLimit * requiredQuantity / 100);
              isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(requiredQuantity.toFixed(3)) && 
                                          parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(maxAllowed.toFixed(3));
            } else if (allowUnderAllocation) {
              const minAllowed = requiredQuantity - (underAllocationLimit * requiredQuantity / 100);
              isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(minAllowed.toFixed(3)) && 
                                          parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(requiredQuantity.toFixed(3));
            }
          }
        }
        
        setIsSaveEnabled(isExactMatch || isWithinAllocationLimits);
      }
    } else if (rmpmChecked) {
     
      const selectedLotItem = updatedInventory?.find(item => item.inventoryBatchNumber === selectedLot) || null;
      const enteredPlannedQty = selectedLotItem ? parseFloat(selectedLotItem.plannedAllocatedQuantity || 0) : 0;
      const hasEnteredValue = enteredPlannedQty > 0;
      
     
      if (allowOverAllocation || allowUnderAllocation) {
        // Require radio selection, entered value, and comment (reason code dropdown is commented out)
        setIsSaveEnabled(
          selectedLot !== null &&
          hasEnteredValue &&
            // ((selectedReason.trim() !== "" &&
            //   selectedReason.trim() !== "EXMRP019") ||
            //   (selectedReason.trim() === "EXMRP019" &&
            //     comment.trim() !== "") ||
            //   (selectedReason.trim() === "" && comment.trim() !== ""))
            comment.trim() !== ""
        );
      } else {
        
        setIsSaveEnabled(
          selectedLot !== null &&
            // ((selectedReason.trim() !== "" &&
            //   selectedReason.trim() !== "EXMRP019") ||
            //   (selectedReason.trim() === "EXMRP019" &&
            //     comment.trim() !== "") ||
            //   (selectedReason.trim() === "" && comment.trim() !== ""))
            comment.trim() !== ""
        );
      }
    } else {
      // If checkbox is not checked, validate based on text inputs and require reason/comment
      const requiredQuantity = parseFloat(
        lotData?.componentAllocationDetails?.componentQuantity || 0
      );
      const totalEnteredQuantity = (updatedInventory || []).reduce(
        (acc, item) => acc + (parseFloat(item.plannedAllocatedQuantity) || 0),
        0
      );
      const isExactMatch =
        totalEnteredQuantity.toFixed(3) === requiredQuantity.toFixed(3);

      // Check if values are within over/under allocation limits (when enabled)
      let isWithinAllocationLimits = false;
      if (allowOverAllocation || allowUnderAllocation) {
        const enteredValuesCount = (updatedInventory || []).filter(
          (item) => parseFloat(item.plannedAllocatedQuantity || 0) > 0
        ).length;
        
        if (enteredValuesCount > 0) {
          if (allowOverAllocation) {
            const maxAllowed = requiredQuantity + (overAllocationLimit * requiredQuantity / 100);
            isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(requiredQuantity.toFixed(3)) && 
                                        parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(maxAllowed.toFixed(3));
          } else if (allowUnderAllocation) {
            const minAllowed = requiredQuantity - (underAllocationLimit * requiredQuantity / 100);
            isWithinAllocationLimits = parseFloat(totalEnteredQuantity.toFixed(3)) >= parseFloat(minAllowed.toFixed(3)) && 
                                        parseFloat(totalEnteredQuantity.toFixed(3)) <= parseFloat(requiredQuantity.toFixed(3));
          }
        }
      }
      
      const isValidAllocation = isExactMatch || isWithinAllocationLimits;

      const areAllLotNumberDetailsEmpty = lotAllocationData?.every(
        (item) => item?.lotNumberAllocationDetails?.length === 0
      );

      if (areAllLotNumberDetailsEmpty) {
        setIsSaveEnabled(
          // isValidAllocation ||
          //   selectedReason.trim() !== "" ||
          isValidAllocation || comment.trim() !== ""
        );
      } else {
        setIsSaveEnabled(
          isValidAllocation &&
            // ((selectedReason.trim() !== "" &&
            //   selectedReason.trim() !== "EXMRP019") ||
            //   (selectedReason.trim() === "EXMRP019" &&
            //     comment.trim() !== ""))
            comment.trim() !== ""
        );
      }
    }
  }, [selectedLot, selectedReason, comment, rmpmChecked, updatedInventory, lotData, lotAllocationData, inputErrors, totalAllocationError, allowOverAllocation, allowUnderAllocation, overAllocationLimit, underAllocationLimit]);


  return (
    <React.Fragment
    style={{
      // maxHeight: '80vh', // or 100% if you're controlling from parent
      overflow: 'auto',  // or 'hidden' to remove scrollbar
    }}>
     {!isClosing && <BackDropLoading />}
      <DialogContent>
        <Grid container justifyContent="flex-end">
          <Typography
            variant="body2"
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              onClose();
              setIsClosing(true);
              requestAnimationFrame(() => {
                onClose();
              });
            }}
          >
            Cancel <CloseIcon style={{ color: "#FF0000" }} fontSize="large" />
          </Typography>
        </Grid>
        <Typography
          style={{
            fontWeight: "700",
            color: "black",
            fontSize: "22px",
            marginBottom: "0.5rem",
            marginLeft: "1rem",
            marginRight: "1rem",
            textAlign: "center",
            position: "sticky",
    top: 0, 
    backgroundColor: "white",
    zIndex: 1000, 
    padding: "0.5rem"
          }}
        >
          Edit Material Planned Allocated Qty. for PO {" "}
          {poData?.scheduleLineDetails?.scheduleAgreementNumber}
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            backgroundColor: "#f2f8fb",
            border: "1px solid #ccc",
            borderRadius: "4px",
            // padding: "3px",
          }}
        >
          <Table className={classes.tablepadding} style={{backgroundColor: "#f2f8fb"}}>
            {/* <TableBody>
              <TableRow style={{ backgroundColor: "#f2f8fb" }}>
                <TableCell>
                  <Typography className={classes.updatedHeader}>
                    CMO/CDMO
                  </Typography>
                  <Typography className={classes.updatedSubHeader}>
                    {poData?.scheduleLineDetails?.vendorName}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography className={classes.updatedHeader}>
                    Plant ID
                  </Typography>
                  <Typography className={classes.updatedSubHeader}>
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.vendorPlant
                    )}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography style={{ fontWeight: "bold" }}>
                    Storage Location ID
                  </Typography>
                  <Typography style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}>
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.storageLocation
                    )}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography className={classes.updatedHeader}>
                    Material code / description
                  </Typography>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}
                  >
                    {presentFormatedData(
                      lotData?.componentAllocationDetails?.componentCode
                    )}
                    /
                    {presentFormatedData(
                      lotData?.componentAllocationDetails?.componentName
                    )}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography className={classes.updatedHeader}>
                    Material BOM qty.
                  </Typography>
                  <Typography className={classes.updatedSubHeader}>
                    {lotData?.componentAllocationDetails?.componentQuantity}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography className={classes.updatedHeader}>UOM</Typography>
                  <Typography className={classes.updatedSubHeader}>
                    {lotData?.componentAllocationDetails?.uom}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody> */}

            <TableHead>
              <TableRow style={{ maxHeight: "2rem" }}>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    {localStorage.collabType === "CMO" ? "Sponsor" : "CMO"}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Plant ID
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Storage Location ID
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                  Sponsor Material Code / Description
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>
                    Material BOM Qty.
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedHeader}>UOM</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow
                style={{
                  backgroundColor: "#f2f8fb",
                  border: "none",
                  maxHeight: "2rem",
                }}
              >
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {localStorage.collabType === "CMO" 
                      ? poData?.scheduleLineDetails?.sponsorName 
                      : poData?.scheduleLineDetails?.vendorName}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.vendorPlant
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}
                  >
                    {presentFormatedData(
                      poData?.scheduleLineDetails?.storageLocation
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography
                    style={{ maxWidth: 250 }}
                    className={classes.updatedSubHeader}
                  >
                    {presentFormatedData(
                      lotData?.componentAllocationDetails?.componentCode
                    )}
                    /
                    {presentFormatedData(
                      lotData?.componentAllocationDetails?.componentName
                    )}
                  </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                    <Typography className={classes.updatedSubHeader}>
                      {lotData?.componentAllocationDetails?.componentQuantity !== undefined || lotData?.componentAllocationDetails?.componentQuantity !== null
                        ? Number(lotData?.componentAllocationDetails?.componentQuantity).toFixed(3)
                        : "NA"}
                    </Typography>
                </TableCell>
                <TableCell style={{ border: "none" }}>
                  <Typography className={classes.updatedSubHeader}>
                    {lotData?.componentAllocationDetails?.uom}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ display: "flex", width: '100%', gap: '16px', marginTop: "16px", marginBottom: "16px", justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Box
            sx={{
              border: "2px solid #ccc",
              borderRadius: 0,
              padding: "8px 24px",
              display: "flex",
              alignItems: "center",
              height: "auto",
              backgroundColor: "#fff",
              flex: 1,
              minWidth: '300px',
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={rmpmChecked}
                  onChange={(e) => {
                    // Clear all errors when switching modes
                    setInputErrors({});
                    setTotalAllocationError("");
                    setErrorInfo("");
                    
                  
                    const resetInventory = (lotData?.inventoryDetails && Array.isArray(lotData.inventoryDetails))
                      ? lotData.inventoryDetails.map(item => ({
                          ...item,
                          plannedAllocatedQuantity: "",
                          disabled: false
                        }))
                      : [];
                    setUpdatedInventory(resetInventory);
                    // Reset deplete instruction checkboxes - uncheck all when mode changes
                    const resetDepleteInstructions = {};
                    resetInventory.forEach((item, idx) => {
                      resetDepleteInstructions[idx] = false;
                    });
                    setDepleteInstructions(resetDepleteInstructions);

                    // Reset selected lot and related state when switching modes
                    setSelectedLot(null);
                    setNetAvailableQty(null);
                    setSelectedLotDataState(null);
                    
                    setrmpmChecked(e.target.checked);

                    // Ensure a radio button is selected if checkbox is checked
                    if (e.target.checked) {
                      // Check if lotNumberAllocationDetails exists but has no plannedAllocatedQuantity
                      const hasLotDetailsWithoutPlannedQty = 
                        Array.isArray(lotData?.lotNumberAllocationDetails) &&
                        lotData.lotNumberAllocationDetails.length > 0 &&
                        !lotData.lotNumberAllocationDetails.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity'));

                      const isLotDetailsEmpty =
                        Array.isArray(lotData?.lotNumberAllocationDetails) &&
                        lotData?.lotNumberAllocationDetails.length === 0;

                      
                      setIsSaveEnabled(false);
                    } else {
                      const requiredQuantity = parseFloat(
                        lotData?.componentAllocationDetails?.componentQuantity ||
                          0
                      );
                      const totalEnteredQuantity = updatedInventory.reduce(
                        (acc, item) =>
                          acc + (parseFloat(item.plannedAllocatedQuantity) || 0),
                        0
                      );
                      const isExactMatch =
                        totalEnteredQuantity.toFixed(3) ===
                        requiredQuantity.toFixed(3);

                      const areAllLotNumberDetailsEmpty = lotAllocationData?.every(
                        (item) => item?.lotNumberAllocationDetails?.length === 0
                      );

                      if (areAllLotNumberDetailsEmpty) {
                        setIsSaveEnabled(
                          // isExactMatch ||
                          //   selectedReason.trim() !== "" ||
                          //   comment.trim() !== ""
                          isExactMatch || comment.trim() !== ""
                        );
                      } else {
                        setIsSaveEnabled(
                          isExactMatch &&
                            // ((selectedReason.trim() !== "" &&
                            //   selectedReason.trim() !== "EXMRP019") ||
                            //   (selectedReason.trim() === "EXMRP019" &&
                            //     comment.trim() !== ""))
                            comment.trim() !== ""
                        );
                      }
                    }
                  }}
                  classes={{ checked: classes.customCheckbox }}
                  disabled={!allowMultipleLotAllocation}
                />
              }
              label={<span style={{ fontSize: '13px' }}>Allocate single batch</span>}
            />
          </Box>
          <Box
            sx={{
              border: "2px solid #ccc",
              borderRadius: 0,
              padding: "8px 24px",
              display: "flex",
              alignItems: "center",
              height: "auto",
              backgroundColor: "#fff",
              flex: 1,
              gap: "24px",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowOverAllocation}
                  onChange={(e) => {
                    setAllowOverAllocation(e.target.checked);
                    if (e.target.checked) {
                      setAllowUnderAllocation(false); // Mutually exclusive
                    }
                    
                    
                    setErrorInfo("");
                    setInputErrors({});
                    setTotalAllocationError("");
                    setDisableReasonCode(false);
                    
                  
                    const resetInventory = (lotData?.inventoryDetails && Array.isArray(lotData.inventoryDetails))
                      ? lotData.inventoryDetails.map(item => ({
                          ...item,
                          plannedAllocatedQuantity: "",
                          disabled: false
                        }))
                      : [];
                    setUpdatedInventory(resetInventory);
                    // Reset deplete instruction checkboxes - uncheck all when mode changes
                    const resetDepleteInstructions = {};
                    resetInventory.forEach((item, idx) => {
                      resetDepleteInstructions[idx] = false;
                    });
                    setDepleteInstructions(resetDepleteInstructions);

                    // Clear selection (selected lot)
                    setSelectedLot(null);
                    setNetAvailableQty(null);
                    setSelectedLotDataState(null);
                    
                    // After clearing values and selection, save should be disabled
                    // Save will be enabled via useEffect when user selects radio and enters value
                    setIsSaveEnabled(false);
                    }}
                  classes={{ checked: classes.customCheckbox }}
                  disabled={!(
                    Array.isArray(lotAllocationData) &&
                    lotAllocationData.length > 0 &&
                    Array.isArray(lotAllocationData[0].lotNumberAllocationDetails) &&
                    lotAllocationData[0].lotNumberAllocationDetails.length > 0 &&
                    lotAllocationData[0].lotNumberAllocationDetails[0].allowOverAllocation
                  )}
                />
              }
              label={<span style={{ fontSize: '13px' }}>Do over allocation</span>}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowUnderAllocation}
                  onChange={(e) => {
                    setAllowUnderAllocation(e.target.checked);
                    if (e.target.checked) {
                      setAllowOverAllocation(false); // Mutually exclusive
                    }
                    
                   
                    setErrorInfo("");
                    setInputErrors({});
                    setTotalAllocationError("");
                    setDisableReasonCode(false);
                    
                 
                    const resetInventory = (lotData?.inventoryDetails && Array.isArray(lotData.inventoryDetails))
                      ? lotData.inventoryDetails.map(item => ({
                          ...item,
                          plannedAllocatedQuantity: "",
                          disabled: false
                        }))
                      : [];
                    setUpdatedInventory(resetInventory);
                    // Reset deplete instruction checkboxes - uncheck all when mode changes
                    const resetDepleteInstructions = {};
                    resetInventory.forEach((item, idx) => {
                      resetDepleteInstructions[idx] = false;
                    });
                    setDepleteInstructions(resetDepleteInstructions);

                    // Clear selection (selected lot)
                    setSelectedLot(null);
                    setNetAvailableQty(null);
                    setSelectedLotDataState(null);
                    
                    // After clearing values and selection, save should be disabled
                    // Save will be enabled via useEffect when user selects radio and enters value
                    setIsSaveEnabled(false);
                    }}
                  classes={{ checked: classes.customCheckbox }}
                  disabled={!(
                    Array.isArray(lotAllocationData) &&
                    lotAllocationData.length > 0 &&
                    Array.isArray(lotAllocationData[0].lotNumberAllocationDetails) &&
                    lotAllocationData[0].lotNumberAllocationDetails.length > 0 &&
                    (lotAllocationData[0].lotNumberAllocationDetails[0].allowUnderAllocation ||
                     lotAllocationData[0].lotNumberAllocationDetails[0].allowUnderAllocation === true)
                  )}
                />
              }
              label={<span style={{ fontSize: '13px' }}>Do under allocation</span>}
            />
          </Box>
        </Box>
        <TableContainer
          component={Paper}
          className={classes.updatedTableContainer}
          style={{
            maxHeight: `calc(48px + 4 * 52px)`,
            overflowY: "auto"
          }}
        >
          <Table className={classes.secondTablepadding} stickyHeader>
            <TableHead>
              <TableRow>
                {rmpmChecked && (
                  <TableCell align="center" className={classes.headerCell}>
                    Selection
                  </TableCell>
                )}
                {/* {localStorage?.collabType === "CMO" && <TableCell className={classes.headerCell}>
                  CMO Material Lot Number
                </TableCell>} */}
                <TableCell className={classes.headerCell} style={{ paddingLeft: '8px' }}>
                 Sponsor Material Batch Number
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Net Available Qty.
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Expiry Date
                </TableCell>
                <TableCell className={classes.headerCell}>
                  Planned Allocated Qty.
                </TableCell>
                <TableCell className={classes.headerCell} align="center">
                  Add Deplete Instruction
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(updatedInventory?.length > 0
                ? updatedInventory
                : lotData?.inventoryDetails || []
              ).map((item, index) => (
                <TableRow key={index}>
                  {rmpmChecked && (
                    <TableCell align="center">
                      <Radio
                        value={item.inventoryBatchNumber}
                        checked={selectedLot === item.inventoryBatchNumber}
                        onChange={(e) => {
                          // Clear previously selected radio button's entered value when switching in single batch mode with over/under allocation
                          const componentQuantity = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                          let newInventory = [...updatedInventory];
                          
                          if (rmpmChecked && (allowOverAllocation || allowUnderAllocation)) {
                            // In single batch mode with over/under allocation, clear previous selection's value
                            if (selectedLot && selectedLot !== e.target.value) {
                              newInventory = updatedInventory.map((lotItem) => {
                                if (lotItem.inventoryBatchNumber === selectedLot) {
                                  // Clear the previously selected lot's entered value
                                  return {
                                    ...lotItem,
                                    plannedAllocatedQuantity: "",
                                  };
                                }
                                return lotItem;
                              });
                              setUpdatedInventory(newInventory);
                            }
                          }
                          
                          setSelectedLot(e.target.value);

                          // Reset all deplete instruction checkboxes when selection changes in single batch mode
                          const resetDepleteInstructions = {};
                          updatedInventory.forEach((_, idx) => {
                            resetDepleteInstructions[idx] = false;
                          });
                          setDepleteInstructions(resetDepleteInstructions);

                          // Get the selected lot's net available quantity
                          const selectedLotData = (newInventory?.length > 0 ? newInventory : lotData?.inventoryDetails || [])
                          .find(lotItem => lotItem.inventoryBatchNumber === e.target.value);
                          const selectedNetAvailableQty = parseFloat(selectedLotData?.netAvailableQuantity || 0);
                          
                          setNetAvailableQty(parseFloat(selectedLotData?.netAvailableQuantity || 0))
                          setSelectedLotDataState(selectedLotData || null);
                          
                          // When single batch is checked without over/under allocation, set planned allocated qty to Material BoM Qty for selected lot only
                          if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                            const finalInventory = newInventory.map((lotItem) => {
                              if (lotItem.inventoryBatchNumber === e.target.value) {
                                // Set Material BoM Qty for the newly selected lot
                                return {
                                  ...lotItem,
                                  plannedAllocatedQuantity: componentQuantity.toFixed(3),
                                };
                              } else {
                                // Clear planned allocated qty for all other lots
                                return {
                                  ...lotItem,
                                  plannedAllocatedQuantity: "",
                                };
                              }
                            });
                            setUpdatedInventory(finalInventory);
                          }
                          
                          // Clear errors - validation will happen when user enters planned allocated quantity
                          setErrorInfo("");
                          setInputErrors({});
                          setTotalAllocationError("");
                          setDisableReasonCode(false);

                          // Check if lotNumberAllocationDetails exists but has no plannedAllocatedQuantity
                          const hasLotDetailsWithoutPlannedQty = 
                            Array.isArray(lotData?.lotNumberAllocationDetails) &&
                            lotData.lotNumberAllocationDetails.length > 0 &&
                            !lotData.lotNumberAllocationDetails.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity'));

                          const isLotDetailsEmpty =
                            Array.isArray(lotData?.lotNumberAllocationDetails) &&
                            lotData?.lotNumberAllocationDetails.length === 0;

              

                          // Get the selected lot's entered planned allocated quantity value
                          const selectedLotItem = newInventory?.find(item => item.inventoryBatchNumber === e.target.value) ||
                                                   updatedInventory?.find(item => item.inventoryBatchNumber === e.target.value) ||
                                                   null;
                          const enteredPlannedQty = selectedLotItem ? parseFloat(selectedLotItem.plannedAllocatedQuantity || 0) : 0;
                          const hasEnteredValue = enteredPlannedQty > 0;

                          if (hasLotDetailsWithoutPlannedQty || isLotDetailsEmpty) {
                            
                            if (allowOverAllocation || allowUnderAllocation) {
                              setIsSaveEnabled(e.target.value !== "" && hasEnteredValue);
                            } else {
                              // When no over/under allocation, value is auto-set to BOM quantity, so just check radio selection
                              setIsSaveEnabled(e.target.value !== "");
                            }
                          } else {
                          
                            if (allowOverAllocation || allowUnderAllocation) {
                              setIsSaveEnabled(
                                e.target.value !== "" &&
                                hasEnteredValue &&
                                  // ((selectedReason.trim() !== "" &&
                                  //   selectedReason.trim() !== "EXMRP019") ||
                                  //   (selectedReason.trim() === "EXMRP019" &&
                                  //     comment.trim() !== "") ||
                                  //   (selectedReason.trim() === "" && comment.trim() !== ""))
                                  comment.trim() !== ""
                              );
                            } else {
                              // No over/under allocation: value is auto-set, just need radio and comment
                              setIsSaveEnabled(
                                e.target.value !== "" &&
                                  // ((selectedReason.trim() !== "" &&
                                  //   selectedReason.trim() !== "EXMRP019") ||
                                  //   (selectedReason.trim() === "EXMRP019" &&
                                  //     comment.trim() !== "") ||
                                  //   (selectedReason.trim() === "" && comment.trim() !== ""))
                                  comment.trim() !== ""
                              );
                            }
                          }
                        }}
                        className={
                          selectedLot === item.inventoryBatchNumber
                            ? classes.customRadio
                            : ""
                        }
                        disabled={(() => {
                          const netQty = parseFloat(item.netAvailableQuantity || 0);
                          const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                          
                          // When single batch is checked without over/under allocation, only enable if Net Available Qty >= Material BoM Qty
                          if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                            return netQty < componentQty;
                          }
                          
                          if (allowUnderAllocation) {
                            const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                            return netQty < minAllowed;
                          }
                          
                          return netQty < componentQty;
                        })()}
                        style={{
                          opacity: (() => {
                            const netQty = parseFloat(item.netAvailableQuantity || 0);
                            const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                            
                            // When single batch is checked without over/under allocation, only show if Net Available Qty >= Material BoM Qty
                            if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                              return netQty < componentQty ? 0.5 : 1;
                            }
                            
                            if (allowUnderAllocation) {
                              const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                              return netQty < minAllowed ? 0.5 : 1;
                            }
                            
                            return netQty < componentQty ? 0.5 : 1;
                          })(),
                          cursor: (() => {
                            const netQty = parseFloat(item.netAvailableQuantity || 0);
                            const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                            
                            // When single batch is checked without over/under allocation, only enable if Net Available Qty >= Material BoM Qty
                            if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                              return netQty < componentQty ? "not-allowed" : "pointer";
                            }
                            
                            if (allowUnderAllocation) {
                              const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                              return netQty < minAllowed ? "not-allowed" : "pointer";
                            }
                            
                            return netQty < componentQty ? "not-allowed" : "pointer";
                          })(),
                        }}
                      />
                    </TableCell>
                  )}
                  {/* {localStorage?.collabType === "CMO" && <TableCell>{item?.cmoInventoryBatchNumber || 'N/A'}</TableCell>} */}
                  <TableCell style={{ paddingLeft: '8px' }}>
                    {item.inventoryBatchNumber}
                    {item?.batchNearExpiry ? (
                      <FlagIcon
                        style={{
                          color: "yellow",
                          fontSize: 28, // Small size
                          stroke: "black", // Outline color
                          strokeWidth: 1.5, // Adjust for thinness
                        }}
                      />
                    ) : null}
                  </TableCell>
                  <TableCell>
                    {item.netAvailableQuantity !== undefined && item.netAvailableQuantity !== null
                      ? Number(item.netAvailableQuantity).toFixed(3)
                      : "NA"}
                  </TableCell>
                  <TableCell>
                    {dateFormated(
                      item.inventoryExpiryDate,
                      "DD-MMM-YYYY",
                      "NA"
                    ).toUpperCase()}
                  </TableCell>
                  <TableCell sx={{ borderBottom: "none", padding: "0" }}>
                    <Box
                      sx={{
                        border: inputErrors[index] ? "2px solid #f44336" : "1px solid #ccc", // Red border when error
                        padding: "3px",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        width: "80%",
                        backgroundColor: inputErrors[index] ? "#ffebee" : (() => {
                          
                          if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                            return "#e0e0e0";
                          }
                         
                          if (rmpmChecked && (allowOverAllocation || allowUnderAllocation)) {
                            return selectedLot !== item.inventoryBatchNumber ? "#e0e0e0" : "transparent";
                          }
                          // In multi-batch mode (allocate single batch unchecked), keep container enabled
                          return "transparent";
                        })(),
                      }}
                    >
                      <TextField
                        variant="standard"
                        type="text"
                        inputProps={{
                          step: "0.001", // Allows decimals with up to 3 decimal places
                          min: "0",
                          pattern: "^[0-9]*\\.?[0-9]{0,3}$", // Allows numbers with up to 3 decimal places
                        }}
                        InputProps={{
                          disableUnderline: true,
                          style: {
                            padding: "2px",
                            fontSize: "14px",
                            backgroundColor: (() => {
                              // Highlight field with error (red background)
                              if (inputErrors[index]) {
                                return "#ffebee"; // Light red background for error
                              }
                              // Disabled state when single batch checked but over/under allocation not checked
                              if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                                return "#e0e0e0"; // Gray background when disabled
                              }
                              
                              if (rmpmChecked && (allowOverAllocation || allowUnderAllocation)) {
                                return selectedLot !== item.inventoryBatchNumber ? "#e0e0e0" : "white";
                              }
                              // In multi-batch mode (allocate single batch unchecked),
                              // always show enabled background; validation will still enforce limits.
                              const netQty = parseFloat(item.netAvailableQuantity || 0);
                              const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                              if (!rmpmChecked) {
                                return "white";
                              }
                              if (allowUnderAllocation) {
                                const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                                return netQty < minAllowed ? "#e0e0e0" : "white";
                              }
                             
                              
                              return netQty < componentQty ? "#e0e0e0" : "white";
                            })(),
                            cursor: (() => {
                              // Disabled cursor when single batch checked but over/under allocation not checked
                              if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                                return "not-allowed";
                              }
                              
                              if (rmpmChecked && (allowOverAllocation || allowUnderAllocation)) {
                                return selectedLot !== item.inventoryBatchNumber ? "not-allowed" : "text";
                              }
                              const netQty = parseFloat(item.netAvailableQuantity || 0);
                              const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                              if (!rmpmChecked) {
                                return "text";
                              }
                              if (allowUnderAllocation) {
                                const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                                return netQty < minAllowed ? "not-allowed" : "text";
                              }
                             
                              
                              return netQty < componentQty ? "not-allowed" : "text";
                            })(),
                          },
                        }}
                        value={(() => {
                          // When single batch is checked without over/under allocation and this lot is selected, show Material BoM Qty
                          if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation && selectedLot === item.inventoryBatchNumber) {
                            const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                            return componentQty.toFixed(3);
                          }
                          return item.plannedAllocatedQuantity || "";
                        })()}
                        onChange={(e) => handleInputChange(index, e.target.value)}
                        fullWidth
                        size="small"
                        error={!!inputErrors[index]} // Highlight field with error border
                        disabled={(() => {
                          // Disable when single batch checked but over/under allocation not checked
                          if (rmpmChecked && !allowUnderAllocation && !allowOverAllocation) {
                            return true;
                          }
                         
                          if (rmpmChecked && (allowOverAllocation || allowUnderAllocation)) {
                            return selectedLot !== item.inventoryBatchNumber;
                          }
                          // In multi-batch mode, allow editing for all rows (subject to item.disabled flag)
                          const netQty = parseFloat(item.netAvailableQuantity || 0);
                          const componentQty = parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0);
                          if (!rmpmChecked) {
                            return item.disabled;
                          }
                          if (allowUnderAllocation) {
                            const minAllowed = componentQty - (underAllocationLimit * componentQty / 100);
                            return netQty < minAllowed || item.disabled;
                          }
                          
                          return netQty < componentQty || item.disabled;
                        })()}
                      />
                    </Box>
                  </TableCell>
                  {/* Add Deplete Instruction checkbox column - allows user to mark if this batch should be depleted */}
                  <TableCell align="center">
                    <Checkbox
                      checked={depleteInstructions[index] || false}
                      onChange={(e) => {
                        // Update deplete instruction state for this specific row
                        setDepleteInstructions((prev) => ({
                          ...prev,
                          [index]: e.target.checked,
                        }));
                      }}
                      classes={{ checked: classes.customCheckbox }}
                      disabled={
                        rmpmChecked
                          ? selectedLot !== item.inventoryBatchNumber // Disable for all except selected lot in single batch mode
                          : !(parseFloat(item.plannedAllocatedQuantity) > 0) // Disable if no quantity entered in multiple batch mode
                      }
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Grid container style={{ paddingLeft: 3, paddingTop: 3 }}>
          <Typography
            variant="caption"
            style={{ paddingLeft: 4 }}
          >
            {!rmpmChecked && !allowOverAllocation && !allowUnderAllocation
              ? "Note – Sum of planned allocated qty. should match with the Material BoM qty."
              : rmpmChecked
              ? allowOverAllocation
                ? `Note - Only those material batch numbers that have net available quantity within the over allocation limit (${parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0).toFixed(3)} to ${(parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0) + (overAllocationLimit * parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0) / 100)).toFixed(3)}) can be selected.`
                : allowUnderAllocation
                ? `Note - Only those material batch numbers that have net available quantity within the under allocation limit (${(parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0) - (underAllocationLimit * parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0) / 100)).toFixed(3)} to ${parseFloat(lotData?.componentAllocationDetails?.componentQuantity || 0).toFixed(3)}) can be selected.`
                : "Note - Only those material batch numbers that have net available quantity more than the BOM quantity can be selected."
              : ""}
          </Typography>
        </Grid>
        {/* Always render the error container with fixed height to prevent Save button jump */}
        <Box sx={{ minHeight: 64, mb: 2 }}>
          <Grid container style={{ paddingLeft: 3, paddingTop: 3 }}>
            <ul style={{ margin: 0, paddingLeft: 20, minHeight: 0 }}>
              {/* Row-level errors */}
              {Object.entries(inputErrors).map(([idx, msg]) =>
                msg ? (
                  <li key={idx}>
                    <Typography variant="caption" style={{ color: "red" }}>
                      {msg}
                    </Typography>
                  </li>
                ) : null
              )}
              {/* Total-level error */}
              {totalAllocationError && (
                <li>
                  <Typography variant="caption" style={{ color: "red" }}>
                    {totalAllocationError}
                  </Typography>
                </li>
              )}
            </ul>
          </Grid>
        </Box>
        {errorInfo && (
          (allowOverAllocation || allowUnderAllocation || errorInfo === "Planned Allocated Qty.of a material batch number is more than the Net Available Qty.of that material batch.") && (
            <p style={{ color: "red", margin: "8px 0" }}>{errorInfo}</p>
          )
        )}
        {/* Commented out reason code dropdown */}
        {/* {lotData?.lotNumberAllocationDetails?.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity')) && (
          <Grid container spacing={3} style={{ marginTop: "1rem" }}>
            <Grid item xs={4}>
              <Typography
                variant="subtitle2"
                style={{ marginBottom: "10px", fontWeight: 700 }}
              >
                Reason Code / Description
              </Typography>
              <FormControl
                className={classes.customSelect}
                style={{ width: "600px" }}
              >
                <Select
                  variant="outlined"
                  value={selectedReason}
                  onChange={(e) => {
                    const newReason = e.target.value;
                    setSelectedReason(newReason);
                    
                    // Check if lotNumberAllocationDetails exists but has no plannedAllocatedQuantity
                    const hasLotDetailsWithoutPlannedQty = 
                      Array.isArray(lotData?.lotNumberAllocationDetails) &&
                      lotData.lotNumberAllocationDetails.length > 0 &&
                      !lotData.lotNumberAllocationDetails.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity'));

                    const isLotDetailsEmpty =
                      Array.isArray(lotData?.lotNumberAllocationDetails) &&
                      lotData?.lotNumberAllocationDetails.length === 0;

                    // Require radio selection when checkbox is checked
                    if (rmpmChecked) {
                      // Get the selected lot's entered planned allocated quantity value
                      const selectedLotItem = updatedInventory?.find(item => item.inventoryBatchNumber === selectedLot) || null;
                      const enteredPlannedQty = selectedLotItem ? parseFloat(selectedLotItem.plannedAllocatedQuantity || 0) : 0;
                      const hasEnteredValue = enteredPlannedQty > 0;
                      
                      if (hasLotDetailsWithoutPlannedQty || isLotDetailsEmpty) {
                        // When over/under allocation is enabled, require value to be entered
                        if (allowOverAllocation || allowUnderAllocation) {
                          setIsSaveEnabled(selectedLot !== null && hasEnteredValue);
                        } else {
                          // No over/under allocation: value is auto-set, just need radio
                          setIsSaveEnabled(selectedLot !== null);
                        }
                      } else {
                       
                        if (allowOverAllocation || allowUnderAllocation) {
                          setIsSaveEnabled(
                            selectedLot !== null &&
                            hasEnteredValue &&
                              ((newReason.trim() !== "" &&
                                newReason.trim() !== "EXMRP019") ||
                                (newReason.trim() === "EXMRP019" &&
                                  comment.trim() !== "") ||
                                (newReason.trim() === "" && comment.trim() !== ""))
                          );
                        } else {
                          setIsSaveEnabled(
                            selectedLot !== null &&
                              ((newReason.trim() !== "" &&
                                newReason.trim() !== "EXMRP019") ||
                                (newReason.trim() === "EXMRP019" &&
                                  comment.trim() !== "") ||
                                (newReason.trim() === "" && comment.trim() !== ""))
                          );
                        }
                      }
                    } else {
                      const requiredQuantity = parseFloat(
                        lotData?.componentAllocationDetails
                          ?.componentQuantity || 0
                      );
                      const totalEnteredQuantity = updatedInventory.reduce(
                        (acc, item) =>
                          acc +
                          (parseFloat(item.plannedAllocatedQuantity) || 0),
                        0
                      );
                      const isExactMatch =
                        totalEnteredQuantity.toFixed(3) ===
                        requiredQuantity.toFixed(3);

                      const areAllLotNumberDetailsEmpty = lotAllocationData?.every(
                        (item) => item?.lotNumberAllocationDetails?.length === 0
                      );

                      if (areAllLotNumberDetailsEmpty) {
                        setIsSaveEnabled(
                          isExactMatch ||
                            newReason.trim() !== "" ||
                            comment.trim() !== ""
                        );
                      } else {
                        setIsSaveEnabled(
                          isExactMatch &&
                            ((newReason.trim() !== "" &&
                              newReason.trim() !== "EXMRP019") ||
                              (newReason.trim() === "EXMRP019" &&
                                comment.trim() !== ""))
                        );
                      }
                    }
                  }}
                  displayEmpty
                  className={classes.customSelectSty}
                  disabled={disableReasonCode || errorInfo}
                >
                  <MenuItem value="" disabled>
                    Select Reason Code
                  </MenuItem>
                  {reasonCodes?.map((reason) => (
                    <MenuItem key={reason.reasonCode} value={reason.reasonCode}>
                      {reason.reasonCode} / {reason.reasonDescription || "-"}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <Typography
                variant="subtitle2"
                style={{ marginBottom: "10px", fontWeight: 700 }}
              >
                Reason code description
              </Typography>
              <Typography>
                {reasonCodes?.find((r) => r.reasonCode === selectedReason)
                  ?.reasonDescription || "-"}
              </Typography>
            </Grid>
          </Grid>
        )} */}
        {lotData?.lotNumberAllocationDetails?.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity')) && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  variant="subtitle2"
                  style={{ marginBottom: "10px", fontWeight: 700 }}
                >
                  Comment<span style={{ color: "red" }}>  *</span>
                </Typography>
                <TextField
                className={`edit-material-comment ${classes.textField} ${classes.commentField}`}
                  fullWidth
                  multiline
                  rows={4}
                  value={comment}
                  onChange={(e) => {
                     if(e.target.value.length < 256){
                    setComment(e.target.value);
                  }
                    
                    // Check if lotNumberAllocationDetails exists but has no plannedAllocatedQuantity
                    const hasLotDetailsWithoutPlannedQty = 
                      Array.isArray(lotData?.lotNumberAllocationDetails) &&
                      lotData.lotNumberAllocationDetails.length > 0 &&
                      !lotData.lotNumberAllocationDetails.some(lot => lot.hasOwnProperty('plannedAllocatedQuantity'));

                    const isLotDetailsEmpty =
                      Array.isArray(lotData?.lotNumberAllocationDetails) &&
                      lotData?.lotNumberAllocationDetails.length === 0;

                    // Require radio selection when checkbox is checked
                    if (rmpmChecked) {
                      // Get the selected lot's entered planned allocated quantity value
                      const selectedLotItem = updatedInventory?.find(item => item.inventoryBatchNumber === selectedLot) || null;
                      const enteredPlannedQty = selectedLotItem ? parseFloat(selectedLotItem.plannedAllocatedQuantity || 0) : 0;
                      const hasEnteredValue = enteredPlannedQty > 0;
                      
                      if (hasLotDetailsWithoutPlannedQty || isLotDetailsEmpty) {
                        // When over/under allocation is enabled, require value to be entered
                        if (allowOverAllocation || allowUnderAllocation) {
                          setIsSaveEnabled(selectedLot !== null && hasEnteredValue);
                        } else {
                          // No over/under allocation: value is auto-set, just need radio
                          setIsSaveEnabled(selectedLot !== null);
                        }
                      } else {
                       
                        if (allowOverAllocation || allowUnderAllocation) {
                          setIsSaveEnabled(
                            selectedLot !== null &&
                            hasEnteredValue &&
                              // ((selectedReason !== "" &&
                              //   selectedReason !== "EXMRP019") ||
                              //   (selectedReason === "EXMRP019" &&
                              //     e.target.value.trim() !== "") ||
                              //   (selectedReason === "" && e.target.value.trim() !== ""))
                               e.target.value.trim() !== ""
                          );
                        } else {
                          setIsSaveEnabled(
                            selectedLot !== null &&
                              // ((selectedReason !== "" &&
                              //   selectedReason !== "EXMRP019") ||
                              //   (selectedReason === "EXMRP019" &&
                              //     e.target.value.trim() !== "") ||
                              //   (selectedReason === "" && e.target.value.trim() !== ""))
                              e.target.value.trim() !== ""
                          );
                        }
                      }
                    } else {
                      const requiredQuantity = parseFloat(
                        lotData?.componentAllocationDetails?.componentQuantity ||
                          0
                      );
                      const totalEnteredQuantity = updatedInventory.reduce(
                        (acc, item) =>
                          acc + (parseFloat(item.plannedAllocatedQuantity) || 0),
                        0
                      );
                      const isExactMatch =
                        totalEnteredQuantity.toFixed(3) ===
                        requiredQuantity.toFixed(3);

                      const areAllLotNumberDetailsEmpty = lotAllocationData?.every(
                        (item) => item?.lotNumberAllocationDetails?.length === 0
                      );

                      if (areAllLotNumberDetailsEmpty) {
                        setIsSaveEnabled(
                          // isExactMatch ||
                          //   selectedReason.trim() !== "" ||
                           isExactMatch || e.target.value.trim() !== ""
                        );
                      } else {
                        setIsSaveEnabled(
                          isExactMatch &&
                            // ((selectedReason !== "" &&
                            //   selectedReason !== "EXMRP019") ||
                            //   (selectedReason === "EXMRP019" &&
                            //     e.target.value.trim() !== ""))
                            e.target.value.trim() !== ""
                        );
                      }
                    }
                  }}
                  disabled={disableReasonCode || errorInfo}
                  variant="outlined"
                  size="small"
                  placeholder="Enter text here"
                  // InputProps={{
                  //   sx: {
                  //     padding: 0, // Remove outer padding
                  //     '& textarea': {
                  //       padding: '4px',      // Adjust as needed
                  //       fontSize: '12px',    // Smaller text
                  //       lineHeight: '1.2',   // Tighter spacing
                  //       height: '0.5rem',    // Effective height (won’t be exact)
                  //     },
                  //   },
                  // }}
                />

              {/* <Typography variant="caption" style={{ color: error && "red" }}>
                Note - If reason code is not entered, comment field is
                mandatory.
              </Typography> */}
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "center", // Centers the button
          // paddingBottom: "16px", // Adds spacing at bottom
          marginBottom:"16px"
        }}
      >
        <Button
          variant="contained"
          color="primary"
          disabled={!isSaveEnabled || disableReasonCode}
          endIcon={<ChevronRight />}
          style={{
            borderRadius: "20px",
            textTransform: "none",
          }}
          onClick={handleSave}
        >
          Save changes
        </Button>
      </DialogActions>

      {/* Legend for Material Near Expiry Flag */}
      <div style={{ 
        margin: "1rem", 
        padding: "0.5rem", 
        backgroundColor: "#f9f9f9", 
        border: "1px solid #e0e0e0", 
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        fontSize: "0.875rem"
      }}>
        <Typography variant="caption" style={{ fontSize: "0.875rem", marginRight: "8px" }}>
          Legend:
        </Typography>
        <FlagIcon
          style={{
            color: "yellow",
            fontSize: 20,
            stroke: "black",
            strokeWidth: 1.5,
            marginRight: "8px"
          }}
        />
        <Typography variant="caption" style={{ fontSize: "0.875rem" }}>
          Material near expiry
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default EditPlannedAllocatedQuantityDialog;
